import TYPE from '../storeType'

const state={
  videoContain:{}

};
const action={
  [TYPE.videoContain]({commit, state},msg){
    commit([TYPE.videoContain],msg)
  }
};
const mutations={
  [TYPE.videoContain](state,msg){
    state.videoContain=msg;
  }
};
export default {
  state,
  action,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/portraitBayonet.js